export const VIEWPORT_PADDING = 20;

export const LEGEND_LABEL = 'Labels';

export const MODAL_TYPE = {
  DELETE: 'delete',
  SAVE: 'save',
  SAVE_FIELD: 'save_field'
};

export const SIDEBAR_MODE = {
  AREAS: 'area_list',
  EDIT: 'edit_area',
  REPORT: 'area_reports',
  CREATE_REQUEST: 'create_request',
  REPORTS: 'requests',
  LEGEND: 'labels',
  FIELDS: 'fields'
};

export const AOI_TYPE = {
  AREA: 1,
  FIELD: 2
};

export const SHAPE_NAMES = {
  POLYGON: 'Polygon',
  RECTANGLE: 'Rectangle'
};

export const GET_DATA_INTERVAL = 10000;
export const GET_AREA_DATA_INTERVAL = 5000;

export const FIELD_VALIDATION = {
  PASSWORD: 'Password must be at least 8 characters',
  PASSWORD_MATCH: 'Passwords must match',
  REQUIRED: 'This field is required'
};

export const NO_DATA = 'No data';

export const EMAIL_TEXT = {
  error: 'Failed to send your message, please try again later',
  success: 'Your message has been successfully sent'
};

export const EMAIL_VARIABLES = {
  name: 'name',
  email: 'email',
  message: 'message',
  id: 'id'
};

export const DATE_TYPES = { year: 1, range: 2, season: 3, day: 4 };

export const STORAGE_WELCOME_KEY = 'hide_welcome';

export const DEFAULT_FOLDER_NAME = 'Demo';
export const STONES_FOLDER_NAME = 'Stone detection';
